import { addValidationRule } from 'formsy-react';

import { parseDate } from '../Utils';

addValidationRule<number | null>('minValue', (_model, newValue = null, minValue = null) => {
	if (newValue === null || minValue === null) return true;
	return newValue >= minValue;
});

addValidationRule<number | null>('maxValue', (_model, newValue = null, maxValue = null) => {
	if (newValue === null || maxValue === null) return true;
	return newValue <= maxValue;
});

addValidationRule<string | null>('minDate', (_model, newValue, minValue) => {
	const parsedCurrentDate = parseDate(newValue);
	const parsedMinDate = parseDate(minValue);

	if (!parsedCurrentDate || !parsedMinDate) return true;
	return parsedCurrentDate?.isSameOrAfter(parsedMinDate);
});

addValidationRule<string | null>('maxDate', (_model, newValue, maxValue) => {
	const parsedCurrentDate = parseDate(newValue);
	const parsedMaxDate = parseDate(maxValue);

	if (!parsedCurrentDate || !parsedMaxDate) return true;
	return parsedCurrentDate?.isSameOrBefore(parsedMaxDate);
});

addValidationRule<string | null>('minTime', (_model, newValue, minValue) => {
	const parsedCurrentTime = parseDate(newValue)?.set('year', 1900)?.set('month', 0)?.set('date', 1);
	const parsedMinTime = parseDate(minValue)?.set('year', 1900)?.set('month', 0)?.set('date', 1);

	if (!parsedCurrentTime?.isValid() || !parsedMinTime?.isValid()) return true;
	return parsedCurrentTime.isSameOrAfter(parsedMinTime);
});

addValidationRule<string | null>('maxTime', (_model, newValue, maxValue) => {
	const parsedCurrentTime = parseDate(newValue)?.set('year', 1900)?.set('month', 0)?.set('date', 1);
	const parsedMaxTime = parseDate(maxValue)?.set('year', 1900)?.set('month', 0)?.set('date', 1)?.add(1, 'minute');

	if (!parsedCurrentTime?.isValid() || !parsedMaxTime?.isValid()) return true;
	return parsedCurrentTime.isSameOrBefore(parsedMaxTime);
});

addValidationRule<string | null>('minDateTime', (_model, newValue, minValue) => {
	const parsedCurrentDateTime = parseDate(newValue);
	const parsedMinDateTime = parseDate(minValue);

	if (parsedCurrentDateTime === null || parsedMinDateTime === null) return true;
	return parsedCurrentDateTime?.isSameOrAfter(parsedMinDateTime);
});

addValidationRule<string | null>('maxDateTime', (_model, newValue, maxValue) => {
	const parsedCurrentDateTime = parseDate(newValue);
	const parsedMaxDateTime = parseDate(maxValue);

	if (parsedCurrentDateTime === null || parsedMaxDateTime === null) return true;
	return parsedCurrentDateTime?.isSameOrBefore(parsedMaxDateTime);
});

addValidationRule<string | null>('isPhoneNumber', (_model, newValue) => {
	if (!newValue) return true;
	return /^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$/gi.test(newValue);
});
